import React from 'react'
import './style.css'

export default function Groups() {
    return (
      <div className="form">
           <p>Area Domisili</p>
           <div className="form-group-select">      
            <div className="form-input">
                <select id="Domisili">
                    <option value="Sulawesi Selatan">Sulawesi Selatan</option>
                    <option value="Sulawesi Tenggara">Sulawesi Tenggara</option>
                 </select>
                 <small className="small-select">(Provinsi, Kabupaten/Kota, Kecamatan)</small>
              </div>
              <div className="form-input">
                <select id="Domisili">
                    <option value="Makassar">Makassar</option>
                    <option value="Maros">Maros</option>
                </select>
              </div>
              <div className="form-input">
                <select id="Domisili">
                    <option value="Somba Opu">Somba Opu</option>
                    <option value="Perintis">Perintis</option>
                </select>
             </div>
           </div>
          </div>
    )
}
